<template>
  <div v-if="files.length > 0" class="upload-progress-component">
    <div v-if="totalToLoad > 0" class="progress-bar-ok">
      <div class="level">
        <div class="level-left">{{ uploadingTitle }}</div>
        <div v-if="totalLoaded > 0" class="level-right">
          {{ totalLoaded.toFixed(2) }}Mb of {{ totalToLoad.toFixed(2) }}Mb
        </div>
      </div>

      <div class="bar-total">
        <div
          class="bar-loaded"
          :style="{ width: percentageLoaded + '%' }"
        ></div>
      </div>

      <div class="note">
        <font-awesome-icon icon="exclamation-triangle" /> Leaving the page will
        cause the document upload to fail
      </div>
    </div>

    <div class="failed-files-list">
      <div
        v-for="(item, index) in failedFiles"
        :key="index"
        class="failed-file"
      >
        <span>UPLOAD FAILED {{ item.name }}</span>
        <!--button class="button is-small is-text">RETRY</button-->
        <button class="button is-icon is-small is-text">
          <span class="icon icon-close" @click="removeFile(item)"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadProgress',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      timeoutId: 0,
      files: []
    };
  },
  computed: {
    uploadingTitle() {
      /*
      if (this.totalFilesToLoad > 1)
        return 'Uploading ' + this.totalFilesToLoad + ' files';
      else if (this.totalFilesToLoad == 1)
        return 'Uploading ' + this.totalFilesToLoad + ' file';
      return '';  
        */
      let suf = '';
      if (this.totalFilesToLoad > 1) suf = 's';
      return (
        'Uploading ' +
        (this.total - this.totalFilesLoaded) +
        ' file' +
        suf +
        ' (' +
        this.totalFilesLoaded +
        '/' +
        this.total +
        ' complete)'
      );
    },
    totalLoaded() {
      let accumulator = 0;
      this.files.map(item => {
        if (item.uploadLoaded && !item.errorUploading)
          accumulator +=
            Math.round((item.uploadLoaded / 1024 / 1024) * 100) / 100;
      });
      return accumulator;
    },
    totalToLoad() {
      let accumulator = 0;
      this.files.map(item => {
        if (item.uploadTotal && !item.errorUploading)
          accumulator +=
            Math.round((item.uploadTotal / 1024 / 1024) * 100) / 100;
      });
      return accumulator;
    },
    totalFilesLoaded() {
      let accumulator = 0;
      this.files.map(item => {
        if (item.uploadProgress == 100 && !item.errorUploading) accumulator++;
      });
      return accumulator;
    },
    totalFilesToLoad() {
      let accumulator = 0;
      this.files.map(item => {
        if (item.uploadProgress && !item.errorUploading) accumulator++;
      });
      return accumulator;
    },
    percentageLoaded() {
      return Math.floor((this.totalLoaded / this.totalToLoad) * 100);
    },
    failedFiles() {
      return this.files.filter(item => {
        if (item.errorUploading) return item;
      });
    }
  },
  watch: {
    value() {
      clearTimeout(this.timeoutId);
      this.files = this.value;
    },
    totalLoaded() {
      if (this.failedFiles.length > 0) return;

      clearTimeout(this.timeoutId);
      if (this.totalLoaded > 0 && this.totalLoaded == this.totalToLoad) {
        this.timeoutId = setTimeout(() => {
          this.files = [];
        }, 8000);
      }
    }
  },
  methods: {
    removeFile(item) {
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i] == item) {
          this.files.splice(i, 1);
          return;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-progress-component {
  padding-bottom: $block-spacing * 3;

  .bar-total {
    border-radius: $radius;
    background: $light-gray;
    height: 16px;
    overflow: hidden;

    .bar-loaded {
      width: 0;
      height: 16px;
      background: $success;
    }
  }

  .note {
    font-size: 1.4rem;
    padding-top: 10px;
    color: $danger;
  }

  .failed-file {
    border: solid 1px $danger;
    padding: 2px 10px;
    display: flex;
    align-items: center;
    margin-top: 10px;
    border-radius: $radius;
    color: $danger;
    justify-content: flex-start;

    span {
      margin-right: auto;
    }

    .button {
      margin-left: 5px;
      color: $danger;
    }
  }
}
</style>
